/* Production storefront behaviour, isolated from Nimbus's native carousels. */
(() => {
  if (!customElements.get('vv-card-slider')) {
    class VVCardSlider extends HTMLElement {
      connectedCallback() {
        // Wait for children when sections are inserted by the theme editor or AJAX.
        this.frame = requestAnimationFrame(() => {
          const element = this.querySelector('.vv-product-swiper');
          if (!this.isConnected || !element || this.slider || !window.Swiper) return;
          const count = element.querySelectorAll('.swiper-slide').length;
          if (count < 2) return;
          this.slider = new window.Swiper(element, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            grabCursor: true,
            nested: true,
            pagination: {
              el: element.querySelector('.swiper-pagination'),
              clickable: true,
              bulletElement: 'button',
            },
            navigation: {
              nextEl: element.querySelector('.swiper-button-next'),
              prevEl: element.querySelector('.swiper-button-prev'),
            },
          });
        });
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        if (this.slider) this.slider.destroy(true, true);
        this.slider = null;
      }
    }
    customElements.define('vv-card-slider', VVCardSlider);
  }

  if (window.vvCurrencyFormattingStarted) return;
  window.vvCurrencyFormattingStarted = true;
  const selector = '.price-item, .localization-selector, .country';

  function wrapCurrency(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, {
      acceptNode(node) {
        return node.nodeValue.includes('€') && !node.parentElement.closest('.currency, script, style, textarea, option')
          ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => {
      const fragment = document.createDocumentFragment();
      node.nodeValue.split('€').forEach((part, index) => {
        if (index) {
          const currency = document.createElement('span');
          currency.className = 'currency';
          currency.textContent = '€';
          fragment.append(currency);
        }
        if (part) fragment.append(document.createTextNode(part));
      });
      node.replaceWith(fragment);
    });
  }

  function collectTargets(node, targets) {
    const element = node.nodeType === Node.ELEMENT_NODE ? node : node.parentElement;
    if (!element || !element.isConnected) return;
    const parent = element.closest(selector);
    if (parent) targets.add(parent);
    element.querySelectorAll(selector).forEach((target) => targets.add(target));
  }

  function startCurrencyFormatting() {
    document.querySelectorAll(selector).forEach(wrapCurrency);
    const observer = new MutationObserver((mutations) => {
      const targets = new Set();
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') collectTargets(mutation.target, targets);
        else mutation.addedNodes.forEach((node) => collectTargets(node, targets));
      });
      targets.forEach(wrapCurrency);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startCurrencyFormatting, { once: true });
  } else {
    startCurrencyFormatting();
  }
})();
